var helper = require('../../helper');
var ToastrController = new (require('../../services/ToastrController'));

var PropertyViewingCalendarController = function() {
    var self = this; // Needed for using all constructor variables inside this function, note the difference -> no "this" but "var" at the beginning
}

PropertyViewingCalendarController.prototype.deleteModel = function(CalendarController, EditModalFormController) {

    var self = this;
    var serializedData = EditModalFormController.getFieldsData();

    $.ajax(
        {
            type: 'POST',
            data: serializedData,
            url: helper.getOrigin() + "/property_viewings/delete/" + self.getFormData(serializedData).id,
            dataType: 'json',

            success: function(data) {
                EditModalFormController.clearModal();
                EditModalFormController.closeModal();
                if (data.status == 'error') {
                    ToastrController.showDanger(data.message);
                } else {
                    ToastrController.showSuccess(data.message);
                    CalendarController.render();
                }

            },

            error: function(data) {
                ToastrController.showDanger(data.message);
            }
        });

}

PropertyViewingCalendarController.prototype.getModel = function(modelId, callbackSuccess) {

    $.ajax({
        type: 'POST',
        url: helper.getOrigin() + "/api/property_viewings/get" ,
        data: { 'id' : modelId },
        dataType: 'json',

        success: function(model) {
            callbackSuccess(model);
        },

        error: function (data) {
        }
    });
}

PropertyViewingCalendarController.prototype.getFormData = function(unindexed_array) {

    var indexed_array = {};

    $.map(unindexed_array, function(n, i){
        indexed_array[n['name']] = n['value'];
    });

    return indexed_array;
}

PropertyViewingCalendarController.prototype.updateModel = function(CalendarController, EditModalFormController) {

    var self = this;

    var serializedData = EditModalFormController.getFieldsData();

    $.ajax(
        {
            type: 'POST',
            data: serializedData,
            url: helper.getOrigin() + "/api/property_viewings/update/" + self.getFormData(serializedData).id,
            dataType: 'json',

            success: function (data) {
                EditModalFormController.clearModal();
                EditModalFormController.closeModal();
                if (data.status == 'error') {
                    ToastrController.showDanger(data.message);
                } else {
                    ToastrController.showSuccess(data.message);
                    CalendarController.render();
                }
            },

            error: function (data) {

                var errors = data.responseJSON;

                // Now display all errors from validation
                EditModalFormController.displayErrors(errors);

            }
        });

}


module.exports = PropertyViewingCalendarController;